import Imagem0 from './0';
import Imagem1 from './1';
import Imagem2 from './2';
import Imagem3 from './3';
import Imagem4 from './4';

export default {
  name: 'redondo',
  images: [Imagem0, Imagem1, Imagem2, Imagem3, Imagem4]
};
